import { useState } from "react";
import { api, errMsg } from "../../lib/api";
import { ActionButton } from "../common";
import { Textarea } from "../ui/textarea";

export const RentalPhotoCaption = ({ file, base, canEdit, disabled, onBusyChange, onSaved }) => {
  const [editing, setEditing] = useState(false);
  const [draft, setDraft] = useState("");
  const [error, setError] = useState("");
  const [saving, setSaving] = useState(false);
  const [saved, setSaved] = useState(false);
  const save = async () => {
    if (saving) return;
    setSaving(true); onBusyChange(true); setError("");
    try {
      const { data } = await api.patch(`${base}/${file.id}/caption`, { caption: draft, version: file.caption_version || 0 });
      onSaved(data); setEditing(false); setSaved(true);
    } catch (e) { setError(errMsg(e)); }
    finally { setSaving(false); onBusyChange(false); }
  };
  return <div className="space-y-2">
    <p data-testid={`rental-photo-caption-display-${file.id}`} className="whitespace-pre-wrap break-words text-sm text-foreground [overflow-wrap:anywhere]">{file.caption || "No caption added."}</p>
    {editing ? <>
      <label htmlFor={`rental-photo-caption-input-${file.id}`} className="text-xs font-medium">Photo caption (optional)</label>
      <Textarea id={`rental-photo-caption-input-${file.id}`} data-testid={`rental-photo-caption-input-${file.id}`} value={draft} onChange={(e) => setDraft(e.target.value)} maxLength={1000} rows={3} disabled={disabled} placeholder="Describe damage, delivery conditions, or anything the manager should know…" className="bg-white text-foreground resize-y" />
      <p data-testid={`rental-photo-caption-count-${file.id}`} className="text-xs text-slate-500">{draft.length}/1,000 characters · Leave blank to remove the caption</p>
      <div className="flex flex-wrap gap-2">
        <ActionButton type="button" testId={`rental-photo-caption-save-${file.id}`} disabled={disabled} onClick={save} className="min-h-11">{saving ? "Saving…" : "Save Caption"}</ActionButton>
        <ActionButton type="button" variant="secondary" testId={`rental-photo-caption-cancel-${file.id}`} disabled={disabled} onClick={() => { setEditing(false); setError(""); }} className="min-h-11">Cancel</ActionButton>
      </div>
      {error && <p data-testid={`rental-photo-caption-error-${file.id}`} role="alert" className="text-sm text-red-700 break-words">{error}</p>}
    </> : canEdit && <ActionButton type="button" variant="secondary" testId={`rental-photo-caption-edit-${file.id}`} disabled={disabled} onClick={() => { setDraft(file.caption || ""); setEditing(true); setError(""); setSaved(false); }} className="min-h-11">{file.caption ? "Edit Caption" : "Add Caption"}</ActionButton>}
    {saved && !editing && <p data-testid={`rental-photo-caption-saved-${file.id}`} role="status" className="text-xs text-emerald-700">Caption saved</p>}
  </div>;
};
